/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_In_Reason_Return_From_Packaging_ProcessInputs */

const vi_scl_in_reason_return_from_packaging_process = /** @type {(inputs: Scl_In_Reason_Return_From_Packaging_ProcessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả lại từ quy trình đóng gói`)
};

/**

* @param {Scl_In_Reason_Return_From_Packaging_ProcessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_in_reason_return_from_packaging_process = /** @type {((inputs?: Scl_In_Reason_Return_From_Packaging_ProcessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_In_Reason_Return_From_Packaging_ProcessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_in_reason_return_from_packaging_process(inputs)
});